<template>
    <div class="flex flex-col gap-6">
        <ul class="list-decimal text-indigo-600 list-inside m-0 p-0">
            <li class="mt-1 " v-for="(frequentlyAskedQuestion, index) in getFrequentlyAskedQuestions"
                :key="frequentlyAskedQuestion.id">
                <a :href="'#id_' + index" class="text-indigo-600 text-base leading-7 cursor-pointer hover:underline ">
                    {{ frequentlyAskedQuestion.question }}
                </a>
            </li>
        </ul>
        <hr>
        <div class="flex flex-col gap-y-4">
            <div class="" v-for="(frequentlyAskedQuestion, index) in getFrequentlyAskedQuestions"
                :key="frequentlyAskedQuestion.id">
                <div :id="'id_' + index">
                    <div class="flex-col flex gap-2 list-inside">
                        <div class="text-base break-words font-semibold leading-7">{{ frequentlyAskedQuestion.question }}</div>
                        <div class="text-base break-words leading-7" v-html="frequentlyAskedQuestion.answer"></div>
                        </div>
                    </div>
                </div>
        </div>
        <div class=" fixed" style="left:5%; bottom: 8%;" v-if="scrollpx > 1000">
            <a href="#top" type="button"
                class="rounded-full bg-indigo-600  p-4 text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">
                <p>Return to Top</p>
            </a>
        </div>
    </div>
</template>
<script>
import ProtestRequestApi from "@/services/api/ProtestRequest.js";
export default {
    created() {
        ProtestRequestApi.getFrequentlyAskedQuestions().then((response) => {
            const faqs = response.data.frequently_asked_questions_and_answers || [];
            this.getFrequentlyAskedQuestions = this.moveFirstToThirdFromLast(faqs);

        })

        window.addEventListener('scroll', this.handleScroll);
    },
    data() {
        return {
            getFrequentlyAskedQuestions: '',
            scrollpx: 0
        }
    },
    methods: {
        handleScroll() {
            this.scrollpx = window.scrollY;
      },
        // The first FAQ (as returned from the DB) should display 3rd-from-last
        // instead of first, e.g. [A,B,C,D,E,F] -> [B,C,D,A,E,F].
        moveFirstToThirdFromLast(faqs) {
            if (faqs.length < 3) {
                return faqs;
            }

            const [first, ...rest] = faqs;
            const insertIndex = rest.length - 2;
            rest.splice(insertIndex, 0, first);
            return rest;
        }
    },
}
</script>
